<template>

  <div class="autocomplete d-flex align-center">
    <v-autocomplete :value="value"
                    @input="$emit('input', $event)"
                    :items="types"
                    :label="_label"
                    :menu-props="{ auto: true }"
                    :disabled="disabled"
                    item-text="name"
                    item-value="id"
    />

    <div class="icon" v-if="value">
      <v-btn text icon @click="clear()" v-if="clearable">
        <v-icon>delete</v-icon>
      </v-btn>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'asset-type-autocomplete',

    props: [ 'value', 'label', 'clearable', 'disabled' ],

    data () {
      return {
        types: []
      }
    },

    computed: {
      _label () {
        return this.label || this.$t('entityNames.asset-types')
      }
    },

    methods: {
      clear () {
        this.$emit('input', null)
      }
    },

    async created () {
      if (!this.$store.state.items['asset-types'].length)
        await this.$store.dispatch('getItems', { model: { name: 'asset-types' } })

      this.types = this.$store.state.items['asset-types']
    },
  }

</script>

<style lang="scss" scoped>
.autocomplete {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
